export default {
  setEngagementFeederTypes(state, payload) {
    state.engagementFeederTypes = payload;
  },
};
